module.exports = __webpack_public_path__ + "static/media/developer.c1d5a50c.svg";